/**
 * ╔══════════════════════════════════════════════════════╗
 * ║  Cart Dependency Logic  v5  — VendiPro Edition       ║
 * ║  Main:  instant-bald-fixing-powder-...               ║
 * ║  Dep:   hair-root-oil-30ml                           ║
 * ╚══════════════════════════════════════════════════════╝
 *
 *  PLACE THIS IN <head> — BEFORE </head> — NO defer/async
 *  <script src="{{ 'cart-dependency.js' | asset_url }}"></script>
 */

;(function () {
  'use strict';

  /* ── CONFIG ─────────────────────────────────────────── */
  var MAIN_VID = 44249032654983; // Replace with your exact Variant ID for Pack of 2
  var DEP   = 'hair-root-oil-30ml';

  /* ── STATE ──────────────────────────────────────────── */
  var depVid    = null;   // dependent variant id (cached)
  var syncing   = false;
  var pending   = false;  // queued sync requested while syncing
  var inited    = false;

  /* ════════════════════════════════════════════════════
     RAW XHR — bypasses our own fetch/XHR patches
  ════════════════════════════════════════════════════ */
  function rawXHR(method, url, body) {
    return new Promise(function (resolve, reject) {
      var x = new window._OrigXHR();
      x.open(method, url, true);
      x.setRequestHeader('Content-Type',    'application/json');
      x.setRequestHeader('Accept',          'application/json');
      x.setRequestHeader('X-Requested-With','XMLHttpRequest');
      x.withCredentials = true;
      x.onload = function () {
        if (x.status >= 200 && x.status < 300) {
          try { resolve(JSON.parse(x.responseText)); }
          catch(e) { reject(e); }
        } else {
          reject(new Error('[CDep] ' + x.status + ' ' + url + ': ' + x.responseText));
        }
      };
      x.onerror = function () { reject(new Error('[CDep] Network: ' + url)); };
      x.send(body ? JSON.stringify(body) : null);
    });
  }

  var getCart     = function () { return rawXHR('GET',  '/cart.js'); };
  var getProduct  = function (h){ return rawXHR('GET',  '/products/' + h + '.js'); };
  var cartAdd     = function (id){ return rawXHR('POST', '/cart/add.js',    { items:[{id:id,quantity:1}] }); };
  var cartChange  = function (id,qty){ return rawXHR('POST', '/cart/change.js', { id:id, quantity:qty }); };

  /* ════════════════════════════════════════════════════
     INTERCEPT fetch + XHR — save originals FIRST
  ════════════════════════════════════════════════════ */
  // Save native XHR before patching (used by rawXHR above)
  window._OrigXHR = window.XMLHttpRequest;

  function patchFetch() {
    var _orig = window.fetch;
    window.fetch = function () {
      var args = Array.prototype.slice.call(arguments);
      var url  = typeof args[0] === 'string' ? args[0] : (args[0] && args[0].url) || '';
      return _orig.apply(window, args).then(function (resp) {
        if (/\/cart\/(add|change|update)(\.js)?/.test(url)) {
          scheduleSync();
        }
        return resp;
      });
    };
  }

  function patchXHR() {
    function PXhr() {
      var x    = new window._OrigXHR();
      var _url = '';
      var origOpen = x.open.bind(x);
      x.open = function (m, u) { _url = u || ''; return origOpen.apply(x, arguments); };
      x.addEventListener('load', function () {
        if (/\/cart\/(add|change|update)(\.js)?/.test(_url)) {
          scheduleSync();
        }
      });
      return x;
    }
    PXhr.prototype = window._OrigXHR.prototype;
    window.XMLHttpRequest = PXhr;
  }

  // Patch immediately so we catch everything from the start
  patchFetch();
  patchXHR();

  /* ════════════════════════════════════════════════════
     FIND ITEMS
  ════════════════════════════════════════════════════ */
  function findMain(items) {
    for (var i = 0; i < items.length; i++) {
      // Fixed: using MAIN_VID instead of MAIN_VARIANT_ID
      if (items[i].variant_id === MAIN_VID) return items[i];
    }
    return null;
  }

  function findDep(items) {
    for (var i = 0; i < items.length; i++) {
      var it = items[i];
      if (it.variant_id === depVid || it.handle === DEP || it.product_handle === DEP) return it;
    }
    return null;
  }

  /* ════════════════════════════════════════════════════
     CART DRAWER REFRESH — VendiPro specific
     We try every known method so at least one works
  ════════════════════════════════════════════════════ */
  function refreshDrawer() {
    /* ── Dawn Theme Safe Refresh ── */
    var sectionIds = ['cart-drawer', 'cart-icon-bubble'];
    rawXHR('GET', '/?sections=' + sectionIds.join(',')).then(function (data) {
      
      // 1. Update Cart Bubble (Header Item Count)
      var bubble = document.getElementById('shopify-section-cart-icon-bubble');
      if (bubble && data['cart-icon-bubble']) {
        bubble.innerHTML = data['cart-icon-bubble'];
      }

      // 2. Update Cart Drawer Safely (So it stays open)
      if (data['cart-drawer']) {
        var tempDiv = document.createElement('div');
        tempDiv.innerHTML = data['cart-drawer'];
        
        var currentDrawer = document.querySelector('cart-drawer');
        var newDrawer = tempDiv.querySelector('cart-drawer');
        
        if (currentDrawer && newDrawer) {
          // Keep the empty/full status classes accurate
          if (newDrawer.classList.contains('is-empty')) {
            currentDrawer.classList.add('is-empty');
          } else {
            currentDrawer.classList.remove('is-empty');
          }
          
          // Update ONLY the inside items, leaving the wrapper alone
          var currentInner = currentDrawer.querySelector('#CartDrawer');
          var newInner = newDrawer.querySelector('#CartDrawer');
          if (currentInner && newInner) {
            currentInner.innerHTML = newInner.innerHTML;
          }
        }
      }

      // 3. Re-hide the Free Item quantity selectors
      setTimeout(lockRows, 150);
      setTimeout(lockRows, 500);
    }).catch(function(e){ 
      console.error('[CDep] Refresh Error:', e);
    });
  }

  /* ════════════════════════════════════════════════════
     CSS — hide qty + remove for dep product
  ════════════════════════════════════════════════════ */
  function injectCSS() {
    if (document.getElementById('cdep-css')) return;
    var s = document.createElement('style');
    s.id = 'cdep-css';
    s.textContent = `
      /* Dependent product — hide quantity controls & remove btn */
      [data-cdep] .quantity,
      [data-cdep] .quantity__button,
      [data-cdep] quantity-popover,
      [data-cdep] .cart-item__quantity-wrapper,
      [data-cdep] .cart-item__quantity,
      [data-cdep] .js-qty__wrapper,
      [data-cdep] .qty-box,
      [data-cdep] .qty-selector,
      [data-cdep] input[name="updates[]"],
      [data-cdep] button[name="minus"],
      [data-cdep] button[name="plus"],
      [data-cdep] .cart-item__remove,
      [data-cdep] cart-remove-button,
      [data-cdep] [data-cart-item-remove],
      [data-cdep] a.cart__remove,
      [data-cdep] button.cart__remove,
      [data-cdep] .remove,
      [data-cdep] .btn-remove,
      [data-cdep] .item-remove,
      [data-cdep] .cart__remove-btn,
      [data-cdep] .product-option,
      [data-cdep] .cart-item__error-text { display: none !important; }

      /* Small badge */
      [data-cdep] .cart-item__details::after,
      [data-cdep] .cart-item__info::after {
        content: "✓ Auto-included with your order";
        display: block;
        font-size: 11px;
        color: #aaa;
        margin-top: 5px;
        letter-spacing: 0.02em;
      }
    `;
    document.head.appendChild(s);
  }

  /* ════════════════════════════════════════════════════
     LOCK ROWS — apply data-cdep to dep product rows
  ════════════════════════════════════════════════════ */
  function lockRows() {
    var rowSelectors = [
      '.cart-item',
      '[data-cart-item]',
      'tr.cart__row',
      '.cart-drawer__item',
      'li[data-product-handle]',
      '.mini-cart__item',
      '.ajaxcart__product',
      '.cart__item',
      '[data-line-item]',
    ].join(',');

    var rows = document.querySelectorAll(rowSelectors);
    rows.forEach(function (row) {
      var isDep = false;

      // Check data-handle attribute
      var h = row.dataset.productHandle || row.dataset.handle || '';
      if (h === DEP) isDep = true;

      // Check link inside row
      if (!isDep) {
        var link = row.querySelector('a[href*="' + DEP + '"]');
        if (link) isDep = true;
      }

      // Check hidden variant input
      if (!isDep && depVid) {
        var inp = row.querySelector('input[value="' + depVid + '"]');
        if (inp) isDep = true;
      }

      // Check any text match on product title (fallback)
      if (!isDep) {
        var title = row.querySelector('.cart-item__name, .cart-item__title, .product-title, .cart__product-title');
        if (title && /hair.?root.?oil/i.test(title.textContent)) isDep = true;
      }

      if (isDep) {
        row.setAttribute('data-cdep', 'true');
      } else {
        row.removeAttribute('data-cdep');
      }
    });
  }

  /* ════════════════════════════════════════════════════
     CORE SYNC
  ════════════════════════════════════════════════════ */
  function doSync() {
    if (syncing) { pending = true; return; }
    syncing = true;

    getCart().then(function (cart) {
      var items = cart.items || [];

      if (!depVid) {
        syncing = false;
        if (pending) { pending = false; scheduleSync(500); }
        return;
      }

      var mainItem = findMain(items);
      var depItem  = findDep(items);
      var mainIn   = !!mainItem;
      var depIn    = !!depItem;
      var depQty   = depItem ? depItem.quantity : 0;

      console.log('[CDep] main=' + mainIn + ' dep=' + depIn + ' depQty=' + depQty);

      function done(changed) {
        syncing = false;
        if (changed) refreshDrawer();
        else         lockRows();
        if (pending) { pending = false; scheduleSync(400); }
      }

      if (mainIn && !depIn) {
        // ADD dep
        console.log('[CDep] → adding dep');
        cartAdd(depVid).then(function () { done(true); }).catch(function (e) {
          console.error('[CDep] add failed:', e);
          syncing = false;
        });

      } else if (mainIn && depQty !== 1) {
        // FIX qty
        console.log('[CDep] → fixing dep qty to 1');
        cartChange(depVid, 1).then(function () { done(true); }).catch(function (e) {
          console.error('[CDep] change failed:', e);
          syncing = false;
        });

      } else if (!mainIn && depIn) {
        // REMOVE dep
        console.log('[CDep] → removing dep');
        cartChange(depVid, 0).then(function () { done(true); }).catch(function (e) {
          console.error('[CDep] remove failed:', e);
          syncing = false;
        });

      } else {
        done(false);
      }

    }).catch(function (e) {
      console.error('[CDep] getCart failed:', e);
      syncing = false;
    });
  }

  var _scheduleTimer = null;
  function scheduleSync(delay) {
    clearTimeout(_scheduleTimer);
    _scheduleTimer = setTimeout(doSync, delay || 350);
  }

  /* ════════════════════════════════════════════════════
     BLOCK user manually removing dep
  ════════════════════════════════════════════════════ */
  function blockDepRemove() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest([
        '.cart-item__remove',
        'cart-remove-button',
        '[data-cart-item-remove]',
        'a.cart__remove',
        'button.cart__remove',
        '.remove-item',
        '.btn-remove',
        '.item-remove',
        '.cart__remove-btn',
      ].join(','));
      if (!btn) return;

      var row = btn.closest([
        '.cart-item', '[data-cart-item]', 'tr.cart__row',
        '.cart-drawer__item', 'li[data-product-handle]',
        '.mini-cart__item', '[data-line-item]',
      ].join(','));
      if (!row) return;

      if (row.hasAttribute('data-cdep')) {
        e.preventDefault();
        e.stopImmediatePropagation();
        console.log('[CDep] blocked dep removal');
      }
    }, true);
  }

  /* ════════════════════════════════════════════════════
     WATCH DOM — re-lock on every cart drawer mutation
  ════════════════════════════════════════════════════ */
  function watchDOM() {
    var observed = new WeakSet();

    function observe(el) {
      if (!el || observed.has(el)) return;
      observed.add(el);
      new MutationObserver(function () { lockRows(); }).observe(el, {
        childList: true, subtree: true,
      });
    }

    function attachAll() {
      [
        'cart-drawer', '#cart-drawer', '.cart-drawer', '[data-cart-drawer]',
        'cart-items',  '.cart-items',  '.cart__items',
        'mini-cart',   '.mini-cart',
        '#CartDrawer', '#cart-notification',
        'main', 'body',
      ].forEach(function (sel) {
        document.querySelectorAll(sel).forEach(observe);
      });
    }

    attachAll();
    setTimeout(attachAll, 1500);
    setTimeout(attachAll, 3000);
  }

  /* ════════════════════════════════════════════════════
     THEME EVENTS — listen for all common cart events
  ════════════════════════════════════════════════════ */
  function listenEvents() {
    var evts = [
      'cart:item-added','cart:item-removed','cart:updated','cart:change',
      'cart:refresh','on:cart:updated','theme:cart:added',
      'ajaxCart:itemAdded','ajaxCart:updated','product:added-to-cart',
      'cart-updated','variant:add','line-item:change',
    ];
    evts.forEach(function (name) {
      document.addEventListener(name, function () { scheduleSync(200); });
      window.addEventListener(name,   function () { scheduleSync(200); });
    });
  }

  /* ════════════════════════════════════════════════════
     CHECKOUT GUARD
  ════════════════════════════════════════════════════ */
  function guardCheckout() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest([
        "[name='checkout']",
        '.cart__checkout-button',
        'a[href="/checkout"]',
        '[data-checkout]',
        '.checkout-btn',
        '#checkout',
      ].join(','));
      if (!btn) return;

      e.preventDefault();
      e.stopImmediatePropagation();

      getCart().then(function (cart) {
        var items   = cart.items || [];
        var hasMain = !!findMain(items);
        var hasDep  = !!(findDep(items));

        if (hasDep && !hasMain) {
          cartChange(depVid, 0).then(function () {
            refreshDrawer();
            alert('Hair Root Oil can only be purchased with the Bald Fixing Powder. It has been removed.');
          });
          return;
        }

        // Allow checkout
        if (btn.tagName === 'A') { window.location.href = btn.href; }
        else { var form = btn.closest('form'); if (form) form.submit(); else window.location.href = '/checkout'; }
      }).catch(function () {
        if (btn.tagName === 'A') { window.location.href = btn.href; }
        else { btn.closest('form') && btn.closest('form').submit(); }
      });
    }, true);
  }

  /* ════════════════════════════════════════════════════
     INIT (DOM-dependent parts)
  ════════════════════════════════════════════════════ */
  function domReady() {
    if (inited) return;
    inited = true;

    console.log('[CDep] v5 DOM ready — VendiPro mode');

    injectCSS();
    listenEvents();
    blockDepRemove();
    watchDOM();
    guardCheckout();

    // Load dep variant id then sync
    getProduct(DEP).then(function (prod) {
      depVid = prod.variants[0].id;
      console.log('[CDep] depVid:', depVid);
      doSync();
    }).catch(function (e) {
      console.error('[CDep] Cannot load dep product "' + DEP + '":', e);
    });

    // Safety net
    setInterval(function () { if (!syncing) doSync(); }, 5000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', domReady);
  } else {
    domReady();
  }

})();